// trim then to snake_case
export function toSnakeCase(str) {
    return (str ?? "").trim().toLowerCase().replace(/ /g, "_");
}

//  trim then to camelCase
export function toCamelCase(str) {
    return (str ?? "").replace(/([-_][a-z])/ig, ($1) => {
        return $1.toUpperCase()
            .replace('-', '')
            .replace('_', '');
    });
}